export default "__VITE_ASSET__e$6TWIfb__"